<template>
    <div class="container" >
            <h3>{{ $store.getters['EventStore/eventInfo'].name }} </h3>
            <h1>   Cupoms de desconto    </h1>
            
            <div class="row">
                    <div class="col-6">
                        <b-button @click="toggleForm" variant="primary">Criar Novo Cupom</b-button>
                    </div>
                    
                    <div class="col-2 tr">
                          
                    </div>

                    <div class="col-4">
                            <router-link class='btn btn-primary' to="registrations"> Ver equipes </router-link>
                            <!-- <button class='btn btn-primary mt2 ' @click="downloadCSV"> Download equipes em tabela </button>
                            <button class='btn btn-primary mt2' @click="downloadMemberCSV"> Download ,embros em tabela </button> -->
                            <!-- <div> <small> <input v-model="downloadMember" type="checkbox" /> Incluir Membros  </small> </div> -->
                    </div>
            </div>
            <div class="row" >

                    <div class="col-8">
                            
                            <!-- <input type="search" /> -->
                          <b-form v-if="showForm" @submit.prevent="submitCupom">
                              <b-form-group label="Código" label-for="code">
                                  <b-form-input id="code" v-model="newCupom.code" required></b-form-input>
                              </b-form-group>
                              <b-form-group label="Descrição" label-for="description">
                                  <b-form-input id="description" v-model="newCupom.description" required></b-form-input>
                              </b-form-group>
                              <b-form-group label="Expiração" label-for="expiration">
                                  <b-form-input id="expiration" v-model="newCupom.expiration" type="date" required></b-form-input>
                              </b-form-group>
                              <b-form-group label="Quantidade" label-for="quantity">
                                  <b-form-input id="quantity" v-model="newCupom.quantity" type="number" required></b-form-input>
                              </b-form-group>
                              <b-form-group label="Tipo de Quantidade" label-for="tipoQuantidade"></b-form-group>
                                <b-form-radio-group id="tipoQuantidade" v-model="newCupom.tipoQuantidade" :options="tipoQuantidadeOptions" required></b-form-radio-group>
                              </b-form-group>
                              <b-form-group label="Desconto" label-for="discount">
                                  <b-form-input id="discount" v-model="newCupom.discount" type="number" required></b-form-input>   <b-form-checkbox id="isPercent" v-model="newCupom.isPercent">Percentual (%)</b-form-checkbox>
                              </b-form-group>
                              
                              <b-button type="submit" variant="primary">Criar Cupom</b-button>
                          </b-form>
                          <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
                          <!-- <h4>Lista de Cupoms</h4> -->
                           <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Descrição</th>
                                        <th>Expiração</th>
                                        <th>Quantidade</th>
                                        <th>Desconto</th>
                                        <!-- <th>É Percentual</th> -->
                                        <th>Usado</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="cupom in cupomsList" :key="cupom.id" :class="{'active': new Date(cupom.expiration) > new Date() && cupom.quantity > cupom.used, 'inactive': new Date(cupom.expiration) <= new Date() || cupom.quantity <= cupom.used}">
                                        <td>{{ cupom.code }}</td>
                                        <td>{{ cupom.description }}</td>
                                        <td>{{ new Date(cupom.expiration).toLocaleDateString() }}</td>
                                        <td>{{ cupom.quantity }} - {{ cupom.tipoQuantidade }}</td>
                                        <td>{{ cupom.isPercent ? cupom.discount + ' %' : 'R$ ' + cupom.discount }}</td>
                                        <!-- <td>{{ cupom.isPercent ? 'Sim' : 'Não' }}</td> -->
                                        <td>{{ cupom.used }}</td>
                                        <td>
                                            <button class="btn btn-danger" @click="()=>deleteCupom(cupom.id)">Excluir</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                    </div>

                    
            </div>



      

           

            
        
    </div>
</template>


<script>
import api from '@/api';
export default {
    data(){
            return {
                    status:false,
                    paymentfilter:['payed'],
                    categoryfilter:[],
                    displayAs:'table',
                    downloadMember:true,
                    cupomsList:[],
                    newCupom:{
                        code:'',
                        description:'',
                        expiration:'',
                        quantity:1,
                        discount:0,
                        isPercent:false,
                        tipoQuantidade:'compra',
                        id:null
                    },
                    showForm: false,
                    errorMessage: ''
            }
    },

    created:function(){
            this.$store.dispatch('PurchaseStore/loadEventRegistrations', this.$route.params.eventid)
            this.$store.dispatch('EventStore/loadEvent', this.$route.params.eventid)
            this.loadCupomsList()
    },
    computed:{
            id:function(){
                    return this.$route.params.id
            },
            tipoQuantidadeOptions:function(){
                return [
                    {text:'Compra', value:'compra'},
                    {text:'Equipe', value:'equipe'},
                    {text:'Atleta', value:'atleta'}
                ]
            }

          
    },

    methods: {

          loadCupomsList:function(){
            api.getJSON('listCupoms', this.$route.params.eventid)
            .then(res => {
                this.cupomsList = res.data.sort((a, b) => b.id - a.id)
            })
          },
          toggleForm() {
            this.showForm = !this.showForm;
          },
          submitCupom() {
            this.newCupom.eventId = this.$route.params.eventid
            api.postJSON('addCupom', this.newCupom)
                .then(() => {
                    this.loadCupomsList();
                    this.showForm = false;
                    this.errorMessage = '';
                })
                .catch(error => {
                    this.errorMessage = 'Erro ao criar cupom: ' + error.message;
                });
          },
          deleteCupom: function(id) {
            console.log('deleteCupom', id)
                api.deleteJSON('deleteCupom', {id:id, eventId:this.$route.params.eventid})
                .then(() => {  
                    this.loadCupomsList();
                })
                
          }
    }

}
</script>

<style lang="stylus">
    .list-inscricoes{
            tr.payed{
                    border-left: 4px solid green;
            }
            tr.waiting{
                    border-left: 4px solid yellow;
            }
            tr.canceled{
                    border-left: 4px solid red;
            }
    }
    .active td{
        background-color: #e0f0d0;
    }
    .inactive td{
        background-color: #f0e0e0;
    }
</style>
